import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { appToaster } from 'src/app/configs';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';
import * as CryptoJS from "crypto-js";
var AdminHeaderComponent = /** @class */ (function () {
    function AdminHeaderComponent(authenticationService, toasterService, router, adminService, route, location) {
        this.authenticationService = authenticationService;
        this.toasterService = toasterService;
        this.router = router;
        this.adminService = adminService;
        this.route = route;
        this.location = location;
        this.isApplicationEditable = false;
        this.isSignatureUploaded = false;
        this.isSubmit = false;
        this.subscription = new Subscription();
        this.secretKey = "mySecretKey123";
        this.isActiveAp = true;
        this.isActiveBl = true;
        this.isActiveCB = true;
        this.isActiveTW = true;
        this.isActiveDG = true;
        this.isActiveCoop = true;
        this.isActiveCE = true;
    }
    AdminHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.interval();
        this.subscription.add(this.route.queryParams.subscribe(function (data) {
            console.log("data is ================>", data.encryptedData);
            if (data && data.encryptedData) {
                _this.encryptedData = data.encryptedData;
                sessionStorage.setItem('encryptedData', data.encryptedData);
                var _a = tslib_1.__read(_this.location.path().split('?'), 2), path = _a[0], query = _a[1];
                var params = new HttpParams({ fromString: query });
                _this.location.replaceState(path, params.delete('encryptedData').toString());
            }
            // if (data && data.csrfToken && data.encryptedData) {
            //   this.subscription.add(this.applicationService.verifyCSRFToken({ token: data.csrfToken }).subscribe((data: any) => {
            //     this.authenticationService.loginDetailsBs.next(data.response);
            //     this.authenticationService.loggedOutBs.next(false);
            //     this.getCityList();
            //     this.getUserDeatil();
            //     this.applicationService.setSaveAndExit(false);
            //     const [path, query] = this.location.path().split('?');
            //     const params = new HttpParams({ fromString: query });
            //     this.location.replaceState(path, params.delete('csrfToken').toString());
            //   }));
            // } else {
            // }
        }));
        if (sessionStorage.getItem('encryptedData')) {
            this.loginData();
        }
    };
    AdminHeaderComponent.prototype.onClickedOutside = function (e) {
        console.log('Clicked outside:', e);
    };
    AdminHeaderComponent.prototype.loginData = function () {
        this.encryptedData = sessionStorage.getItem('encryptedData');
        var stringWithoutPlus = this.encryptedData.replace(/ /g, "+");
        var decryptedBytes = CryptoJS.AES.decrypt(stringWithoutPlus, this.secretKey);
        var decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        this.decryptedData = JSON.parse(decryptedData);
        console.log("decryptedData", this.decryptedData);
        debugger;
        if (this.decryptedData) {
            this.checkLoginStatus();
        }
    };
    AdminHeaderComponent.prototype.checkLoginStatus = function () {
        this.isActiveAp = false;
        this.isActiveBl = false;
        this.isActiveCB = false;
        this.isActiveTW = false;
        this.isActiveDG = false;
        this.isActiveCE = false;
        this.isActiveCoop = false;
        if (this.decryptedData.login_by == 1 || this.decryptedData.login_by == 3) {
            this.isActiveAp = true;
            this.isActiveBl = true;
            this.isActiveCB = true;
            this.isActiveTW = true;
            this.isActiveDG = true;
            this.isActiveCE = true;
            this.isActiveCoop = true;
            return true;
        }
        if (this.decryptedData.login_by == 2) {
            if (this.decryptedData.status == 1) {
                this.isActiveAp = true;
            }
            if (this.decryptedData.bl_status == 1) {
                this.isActiveBl = true;
            }
            if (this.decryptedData.tw_status == 1) {
                this.isActiveTW = true;
            }
            if (this.decryptedData.cb_status == 1) {
                this.isActiveCB = true;
            }
            if (this.decryptedData.dg_status == 1) {
                this.isActiveDG = true;
            }
            if (this.decryptedData.ce_status == 1) {
                this.isActiveCE = true;
            }
            if (this.decryptedData.coop_status == 1) {
                this.isActiveCoop = true;
            }
        }
    };
    AdminHeaderComponent.prototype.getUserDetail = function () {
        var _this = this;
        this.subscription.add(this.authenticationService.getUserInfo().subscribe(function (user) {
            _this.currentUser = user ? user : null;
            if (_this.currentUser) {
                clearInterval(_this.intervalID);
            }
        }));
    };
    AdminHeaderComponent.prototype.interval = function () {
        var _this = this;
        this.intervalID = setInterval(function () {
            _this.getUserDetail();
        }, 2000);
    };
    AdminHeaderComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    AdminHeaderComponent.prototype.onClickLogout = function () {
        this.authenticationService.logout();
        this.toasterService.success(appToaster.logoutSuccess);
        window.location.href = environment.ap;
        // this.router.navigate(['auth/sign-in'], {queryParams : {type : 'admin'}});
    };
    AdminHeaderComponent.prototype.navigateToCityAdmin = function () {
        this.router.navigate(['admin/city-admin']);
    };
    AdminHeaderComponent.prototype.navigateToStaffAdmin = function () {
        this.router.navigate(['admin/staff']);
    };
    AdminHeaderComponent.prototype.navigateToAdminIndexPage = function () {
        this.router.navigate(['admin/index']);
    };
    AdminHeaderComponent.prototype.signatureUpload = function () {
        var _this = this;
        var formData = new FormData();
        this.isSubmit = true;
        if (this.selectedFile) {
            formData.append('signature', this.selectedFile);
            this.subscription.add(this.adminService.managerUploadSignature(formData).subscribe(function (data) {
                _this.authenticationService.setUser(data);
                _this.toasterService.success("Signature uploaded successfully");
                _this.subscription.add(_this.authenticationService.getUserInfo().subscribe(function (user) {
                    _this.currentUser = user ? user : null;
                }));
                _this.signatureUpl.nativeElement.click();
                _this.clear();
            }));
        }
        else {
            return false;
        }
    };
    AdminHeaderComponent.prototype.clear = function () {
        this.isSubmit = false;
        this.isSignatureUploaded = false;
        this.selectedFile = null;
        this.signatureFileName = '';
    };
    AdminHeaderComponent.prototype.selectFile = function (event) {
        this.selectedFile = event.target.files[0];
        this.signatureFileName = event.target.files[0].name;
        this.isSignatureUploaded = true;
    };
    AdminHeaderComponent.prototype.openUploadedSignature = function () {
        return;
        if (this.currentUser.signature) {
            window.open(environment.host + environment.imageBasePath + this.currentUser.signature, '_blank');
        }
    };
    AdminHeaderComponent.prototype.deleteUploadedSignature = function () {
        var _this = this;
        if (this.currentUser.signature && this.currentUser.signature != 'null') {
            var formData = new FormData();
            formData.append('signature', null);
            this.subscription.add(this.adminService.managerUploadSignature(formData).subscribe(function (data) {
                _this.authenticationService.setUser(data);
                _this.toasterService.success('Uploaded signature deleted successfully');
                _this.subscription.add(_this.authenticationService.getUserInfo().subscribe(function (user) {
                    _this.currentUser = user ? user : null;
                }));
            }));
            this.signatureUpl.nativeElement.click();
        }
    };
    AdminHeaderComponent.prototype.getCSRFtoken = function () {
        console.log("csrf token value is ");
        // this.subscription.add(this.authenticationService.getCSRFToken().subscribe((data: any) => {
        //     sessionStorage.setItem('csrfToken', data);
        //     console.log("csrf token value is ")
        //   }));
    };
    AdminHeaderComponent.prototype.switchToOtherPortal = function (val) {
        var encryptedData = sessionStorage.getItem('encryptedData');
        var csrfToken = sessionStorage.getItem('csrfToken');
        // console.log("token",csrfToken)
        if (val == 1) {
            // environment.cannabisUrl
            window.location.href = environment.cannabisUrl + "admin/index?csrfToken=" + csrfToken + "&encryptedData=" + encryptedData;
        }
        else if (val == 2) {
            // environment.tradeWasteUrl
            window.location.href = environment.tradeWasteUrl + "admin/index?csrfToken=" + csrfToken + "&encryptedData=" + encryptedData;
        }
        else if (val == 4) {
            // environment.busineslicenseURL
            window.location.href = environment.busineslicenseURL + "admin/index?csrfToken=" + csrfToken + "&encryptedData=" + encryptedData;
        }
        else if (val == 5) {
            // window.location.href = environment.dogUrl;
            window.open(environment.dogUrl);
        }
    };
    AdminHeaderComponent.prototype.backToLogin = function () {
        var encryptedData = sessionStorage.getItem('encryptedData');
        window.location.href = environment.ap + "?data=" + encryptedData;
    };
    AdminHeaderComponent.prototype.navigateToIndex = function () {
        window.location.reload();
    };
    AdminHeaderComponent.prototype.onClickCE = function (platformKey) {
        debugger;
        console.log("platformKey", platformKey, this.decryptedData.login_by);
        if (!this.decryptedData) {
            var url = environment.busineslicenseURL;
            window.open(url + "auth/sign-in?id=login", "_blank");
        }
        if (this.decryptedData.login_by == 1 && platformKey == 2) {
            window.open("" + environment.ceUrl + ("?user=user_login&csrfToken=" + this.encryptedData));
        }
        else if ((this.decryptedData.login_by == 3 || this.decryptedData.login_by == 2) && platformKey == 2) {
            window.open(environment.ceUrl + "auth/verify-ce-login?csrfToken=" + this.encryptedData + "&platformKey=" + platformKey);
        }
        else if ((this.decryptedData.login_by == 2 || this.decryptedData.login_by == 1 ||
            this.decryptedData.login_by == 3) && platformKey === 1) {
            window.open(
            // environment.ceUrl
            environment.ceUrl + "auth/verify-ce-login?csrfToken=" + this.encryptedData + "&platformKey=" + platformKey);
        }
    };
    AdminHeaderComponent.prototype.onClickDog = function () {
        this.login_by = this.decryptedData ? this.decryptedData.login_by : null;
        if (!this.decryptedData || this.login_by == 1) {
            var url = environment.dogUrl;
            // url = 'http://localhost:9000/'
            window.open(url);
        }
        else if ((this.login_by == 2 || this.login_by == 3) && this.isActiveDG) {
            var url = environment.dogUrl;
            // url = 'http://localhost:9001/'
            window.location.href = "" + url + "admin/index" + "?csrfToken=" + this.decryptedData.token;
        }
    };
    return AdminHeaderComponent;
}());
export { AdminHeaderComponent };
